import BaseClass from "../BaseClass.js";
import {Calendar} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid'
import listWeekPlugin from '@fullcalendar/list'
import interactionPlugin from '@fullcalendar/interaction';
import deLocale from '@fullcalendar/core/locales/de';
import Da from "@roderickhsiao/emoji-button-locale-data/dist/da";

export default class FullCalendar extends BaseClass {

    constructor(element) {
        super(element);
        this.$dateUrl = null;
        this.$eventUrl = null;
        this.$detailButton = null;
        this.$deleteUrl = null;
        this.$events = null;
        this.$locale = 'de';
        this.$maxMobileWidth = 975;
        this.expectedView = 'dayGridMonth';
        this.$calendarHeader = null;
        this.calenderContent = null;
        this.$prevButton = null;
        this.$nextButton = null;
        this.$todayButton = null;
        this.$currentDateTitle = null;
        this.$filterButtons = null;
        this.$radioCheckBoxFilter = null;
        this.filteredValue = '';

        this.init();
    }

    init() {
        const $dateUrl = this.$element.data('date-preview-url');
        if ($dateUrl !== undefined) {
            this.$dateUrl = $dateUrl;
        }

        const $eventUrl = this.$element.data('event-url');
        if ($eventUrl !== undefined) {
            this.$eventUrl = $eventUrl;
        }

        const $detailUrl = this.$element.data('detail-url');
        if ($detailUrl !== undefined) {
            this.$detailUrl = $detailUrl;
        }

        const $deleteUrl = this.$element.data('delete-url');
        if ($deleteUrl !== undefined) {
            this.$deleteUrl = $deleteUrl;
        }

        const $locale = this.$element.data('locale');
        if ($locale !== undefined) {
            this.$locale = $locale;
        }

        const $maxMobileWidth = this.$element.data('max-mobile-width');
        if ($maxMobileWidth !== undefined) {
            this.$maxMobileWidth = $maxMobileWidth;
            this.expectedView = this.getExpectedCalendarView();
        }

        const calendarContent = this.element.querySelector('[data-type="calendar-content"]');
        if (calendarContent !== undefined) {
            this.calendarContent = calendarContent;
        }

        const $calendarHeader = this.$element.find('[data-type="calendar-header"]');
        if ($calendarHeader !== undefined) {
            this.$calendarHeader = $calendarHeader;
        }

        const $prevButton = this.$calendarHeader.find('[data-type="prev-button"]');
        if ($prevButton !== undefined) {
            this.$prevButton = $prevButton;
        }

        const $confirmButton = this.$element.find('[data-type="confirm-button"]');
        if ($prevButton !== undefined) {
            this.$confirmButton = $confirmButton;
        }

        const $nextButton = this.$calendarHeader.find('[data-type="next-button"]');
        if ($nextButton !== undefined) {
            this.$nextButton = $nextButton;
        }

        const $todayButton = this.$calendarHeader.find('[data-type="today-button"]');
        if ($todayButton !== undefined) {
            this.$todayButton = $todayButton;
        }

        const $filterButtons = this.$calendarHeader.find('[data-type="filter-button"]');
        if ($filterButtons !== undefined) {
            this.$filterButtons = $filterButtons;
        }

        const $radioCheckBoxFilter = this.$element.find('[data-type="checkbox-filter"]input[type="radio"]');
        if ($radioCheckBoxFilter !== undefined) {
            this.$radioCheckBoxFilter = $radioCheckBoxFilter;
        }

        this.initCalendar();

        const $currentDateTitle = this.$calendarHeader.find('[data-type="current-date"]');
        if ($currentDateTitle !== undefined) {
            this.$currentDateTitle = $currentDateTitle;
            this.updateViewTitle();
        }

        this.initCalendarHeaderListener();
        this.initCalendarRefetchEventsListener();

        this.calendar.render();
    }

    initCalendar() {
        const mySelf = this;
        mySelf.calendar = new Calendar(this.calendarContent, {
            plugins: [dayGridPlugin, interactionPlugin, listWeekPlugin],
            initialView: this.expectedView,
            dateIncrement: { months: 1 },
            handleWindowResize: false,
            eventLimit: false,
            longPressDelay: 500,
            selectable: true,
            headerToolbar: false,
            locales: [deLocale],
            aspectRatio: 1.75,
            locale: mySelf.$locale,
            eventTimeFormat: {
                hour: '2-digit',
                minute: '2-digit',
                meridiem: false,
                hour12: false,
            },
            eventDidMount: function (info) {
                let disabled = false;
                let hasConfirm = false;

                if (typeof info.event.extendedProps.disabled != 'undefined') {
                    disabled = info.event.extendedProps.disabled;
                }

                if (!disabled && mySelf.$deleteUrl != null && typeof info.event.extendedProps.attached_ids != 'undefined') {
                    const deleteButton = document.createElement('a');
                    deleteButton.classList.add('fc-delete-button', 'mdi', 'mdi-close-circle');

                    const changeConfirm = function (event) {
                        event.stopPropagation();
                        hasConfirm = true;

                        if (hasConfirm) {
                            let postData = {'ids': info.event.extendedProps.attached_ids};
                            $.post(mySelf.$deleteUrl, postData, function () {
                            }, 'json')
                                .done(function (jsonResponse) {
                                    mySelf.handleAjaxResponse(jsonResponse);
                                    mySelf.calendar.getEventById(info.event.id).remove();

                                    $(document).trigger("toast:show", {
                                        title: 'Event ist gelöscht',
                                        body: 'Event wurde erfolgreich gelöscht',
                                        delay: 1500,
                                        type: "confirmation",
                                        placement: 'end-bottom',
                                    });
                                }).fail(error => console.log(error));
                        }
                        $('#deletePlannedEvent').modal('hide');
                        hasConfirm = false;
                    };

                    const handleDelete = function (event) {
                        event.stopPropagation();
                        const target = event.target;

                        if (target === deleteButton) {
                            $('#deletePlannedEvent').modal('show');
                            $('#deleteConfirmElement').html(info.event.extendedProps.deleteConfirmation);
                            const confirmButton = mySelf.$element.find('[data-type="confirm-button"]')[0];

                            if (confirmButton) {
                                confirmButton.addEventListener('click', changeConfirm, {once: true});
                            } else {
                                console.error('Element #confirmButton nicht gefunden.');
                            }
                        }
                    };
                    deleteButton.removeEventListener('click', handleDelete);
                    deleteButton.addEventListener('click', function (event) {
                        handleDelete(event);
                        event.currentTarget.removeEventListener(event.type, handleDelete);
                    });
                    deleteButton.addEventListener('touchstart', function (event) {
                        handleDelete(event);
                        event.currentTarget.removeEventListener(event.type, handleDelete);
                    });

                    info.el.insertAdjacentElement('beforeend', deleteButton);
                }

                if (mySelf.$detailUrl != null) {
                    var detailButton = document.createElement('a');
                    detailButton.classList.add('fc-delete-button', 'mdi', 'mdi-exit-to-app');
                    var $eventDetailUrl = mySelf.$detailUrl;

                    if (typeof info.event.extendedProps.detail_appendix != 'undefined') {
                        $eventDetailUrl += '/' + info.event.extendedProps.detail_appendix;
                    }
                    //deleteButton.removeEventListener('click', handleDelete);
                    detailButton.addEventListener('click', function (event) {
                        event.stopPropagation();
                        window.open($eventDetailUrl);
                    });
                    detailButton.addEventListener('touchstart', function (event) {
                        event.stopPropagation();
                        window.open($eventDetailUrl);
                    });
                    info.el.insertAdjacentElement('beforeend', detailButton);
                }
            },
            eventClick: function (info) {
                let $contentData = 'date=' + info.event.extendedProps.event_date;
                let disabled = false;

                if (typeof info.event.extendedProps.disabled != 'undefined') {
                    disabled = info.event.extendedProps.disabled;
                }

                if (typeof info.event.extendedProps.attached_ids != 'undefined') {
                    $contentData = 'date=' + info.event.extendedProps.event_date + '&attached_ids=' + info.event.extendedProps.attached_ids;
                }

                if (!disabled) {
                    $(document).trigger('modal:open', {
                        contentUrl: mySelf.$dateUrl,
                        contentData: $contentData
                    });
                }
            },
            dateClick: function (info) {
                // prüft, ob an dem Tag ein Event existiert
                const findData = mySelf.$events.find((row) => row.event_date === info.dateStr);
                // prüfen ob das Datum in der Vergangenheit liegt
                const calendarDate = new Date(info.dateStr);
                const today = new Date().setHours(0, 0, 0, 0);
                const pastDate = (calendarDate < today);

                if (findData || !pastDate) {
                    const $contentData = 'date=' + info.dateStr
                    $(document).trigger('modal:open', {
                        contentUrl: mySelf.$dateUrl,
                        contentData: $contentData
                    });
                }
            },
            windowResize: function (resizeEvent) {
                const expectedViewType = mySelf.getExpectedCalendarView();

                if (resizeEvent.view.type !== expectedViewType) {
                    this.changeView(expectedViewType);
                }
            },
            eventSources: [
                function (fetchInfo, successCallback) {
                    const url = mySelf.$eventUrl + '?' + new URLSearchParams({
                        start: fetchInfo.startStr,
                        end: fetchInfo.endStr,
                    });
                    fetch(url)
                        .then(response => response.json())
                        .then(events => {
                            mySelf.$events = events;

                            // Call the successCallback with the filtered events
                            successCallback(events);
                        })

                }
            ],
            loading: function (isLoading) {

                if (isLoading) {
                    $(document).trigger('show:loading');
                } else {
                    $(document).trigger('hide:loading');
                }
            }
        })
    }

    initCalendarHeaderListener() {
        const mySelf = this;

        if (this.$prevButton !== undefined) {
            this.$prevButton.on("click touchstart", function () {
                mySelf.calendar.prev();
                mySelf.updateTodayButton();
                mySelf.updateViewTitle();
            });
        }

        if (this.$nextButton !== undefined) {
            this.$nextButton.on("click touchstart", function () {
                mySelf.calendar.next();
                mySelf.updateTodayButton()
                mySelf.updateViewTitle();
            });
        }

        if (this.$todayButton !== undefined) {
            this.$todayButton.on("click touchstart", function () {
                mySelf.calendar.today();
                mySelf.updateTodayButton();
                mySelf.updateViewTitle();
            });
        }

        if (this.$radioCheckBoxFilter !== undefined) {

            $(this.$radioCheckBoxFilter).on("click", function () {
                let dataIcon = $(this).attr("data-icon")
                let filterButton = $(this).closest('.filter-buttons').find('[data-type="sort-icon"]');

                filterButton.removeAttr('class')
                filterButton.addClass(dataIcon);

                mySelf.filteredValue = this.value;

                // Remove all events from the calendar
                mySelf.calendar.removeAllEvents();

                // Re-add events based on the filter value
                mySelf.$events.forEach(function (event) {
                    if (event.source === mySelf.filteredValue || mySelf.filteredValue === 'all') {
                        mySelf.calendar.addEvent(event);
                    }
                });

                mySelf.calendar.render();
            });
        }
    }

    updateViewTitle() {
        const currentDateTitle = this.calendar.view.title;
        this.$currentDateTitle.text(currentDateTitle);
    }

    updateTodayButton() {
        if (!this.currentMonth) {
            this.currentMonth = new Date().getMonth();
        }
        const selectedDate = this.calendar.getDate().getMonth();

        this.$todayButton.prop("disabled", false);
        if (selectedDate === this.currentMonth) {
            this.$todayButton.prop("disabled", true);
        }
    }

    getExpectedCalendarView() {
        return $(window).width() > this.$maxMobileWidth ? 'dayGridMonth' : 'listMonth';
    }

    initCalendarRefetchEventsListener() {
        const mySelf = this;

        $(document).on('refetch:calendar:events', function () {
            mySelf.calendar.refetchEvents()
        });
    }
}
